export default class Service {
	constructor() {
		this.key = "crm";
	}
	set(prop, value) {
		this[prop] = value;
	}
}